import { useEffect, useState } from 'react';
import { getVenueList } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export const useVenueList = (excludeFromLoading = false, practiceAreaId = '') => {
  const [venueOptions, setVenueOptions] = useState([]);
  const [isVenueLoading, setIsVenueLoading] = useState(false);

  const loadVenue = (practiceAreaId = '') => {
    setIsVenueLoading(true);
    totalCountEvent('venue')
      .then((response) => {
        getVenueList(response.data, '', 'forward', excludeFromLoading, '', practiceAreaId)
          .then((response) => {
            setVenueOptions(response?.data?.venues);
          })
          .catch((err) => {})
          .finally(() => setIsVenueLoading(false));
      })
      .catch((err) => {
        setIsVenueLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    loadVenue(practiceAreaId);
  }, []);

  return { venueOptions, loadVenue, isVenueLoading };
};
